/**
 * TK-34 lượt 2 / TK-35 lượt 3 — ĐƯỜNG TUYẾN trên bản đồ, THUẦN (không Leaflet) để `kiem-tk33` chạy và phá.
 *
 * TK-35 (lee 22/10): tủ thường lắp GIỮA tuyến ⇒ hai NHÁNH (= ngõ ra cấp điện). Đường tuyến vẽ TỪ TỦ THEO NHÁNH:
 *   tủ → đèn gần nhất của nhánh 1 → đèn kế → …;  tủ → đèn gần nhất của nhánh 2 → …
 *   · thứ tự trong chuỗi = khoảng cách tới tủ TĂNG DẦN (đèn nối tiếp dọc đường; đã tự quyết — topo mesh của card là hình sao,
 *     không nói được thứ tự trên đường);
 *   · đèn CHƯA XẾP (không vị trí), đèn CHƯA GÁN NHÁNH, tủ chưa có toạ độ ⇒ KHÔNG vẽ. ⛔ Không đường giả, không nối tay.
 */
export interface DenNhanh { cabinetId: string; addr: number; nhanh: number | null; pos: { lat: number; lng: number } | null }
export interface TuToaDo { id: string; lat: number | null; lng: number | null }
export type Diem = [number, number];
export type Doan = [Diem, Diem];
/** Một chuỗi: tủ rồi các đèn của nhánh theo thứ tự xa dần; `addrs[i]` là đèn ở `diem[i + 1]`. */
export interface ChuoiNhanh { cabinetId: string; nhanh: number; diem: Diem[]; addrs: number[] }

/** Khoảng cách gần đúng (m) — đủ để SẮP THỨ TỰ trong vài km. */
export function khoangCachM(a: { lat: number; lng: number }, b: { lat: number; lng: number }): number {
  const kLat = 111_320, kLng = 111_320 * Math.cos(((a.lat + b.lat) / 2) * Math.PI / 180);
  return Math.hypot((b.lat - a.lat) * kLat, (b.lng - a.lng) * kLng);
}

export function chuoiTheoNhanh<D extends DenNhanh>(tu: TuToaDo[], den: D[], viTri: (d: D) => { lat: number; lng: number } | null = (d) => d.pos): ChuoiNhanh[] {
  const tuMap = new Map(tu.map((t) => [t.id, t]));
  const nhom = new Map<string, { goc: { lat: number; lng: number }; cabinetId: string; nhanh: number; ds: { addr: number; p: { lat: number; lng: number } }[] }>();
  for (const d of den) {
    const p = viTri(d);
    if (!p || d.nhanh === null || !Number.isInteger(d.nhanh) || d.nhanh < 1) continue;
    const t = tuMap.get(d.cabinetId);
    if (!t || t.lat == null || t.lng == null) continue;
    const k = `${d.cabinetId}:${d.nhanh}`;
    const g = nhom.get(k) ?? { goc: { lat: t.lat, lng: t.lng }, cabinetId: d.cabinetId, nhanh: d.nhanh, ds: [] };
    g.ds.push({ addr: d.addr, p }); nhom.set(k, g);
  }
  const ra: ChuoiNhanh[] = [];
  for (const g of nhom.values()) {
    const xep = [...g.ds].sort((a, b) => khoangCachM(g.goc, a.p) - khoangCachM(g.goc, b.p));
    ra.push({ cabinetId: g.cabinetId, nhanh: g.nhanh, diem: [[g.goc.lat, g.goc.lng], ...xep.map((x): Diem => [x.p.lat, x.p.lng])], addrs: xep.map((x) => x.addr) });
  }
  return ra.sort((a, b) => a.cabinetId.localeCompare(b.cabinetId) || a.nhanh - b.nhanh);
}

/** Các đoạn của một chuỗi: [tủ→đ1], [đ1→đ2], … kèm đèn ở đầu cuối (để tô màu theo nhóm của đèn ấy). */
export function doanCuaChuoi(c: ChuoiNhanh): { doan: Doan; addr: number }[] {
  const r: { doan: Doan; addr: number }[] = [];
  for (let i = 0; i + 1 < c.diem.length; i++) r.push({ doan: [c.diem[i], c.diem[i + 1]], addr: c.addrs[i] });
  return r;
}
